import { render, staticRenderFns } from "./ProxyRouteList.vue?vue&type=template&id=b2dd828e&scoped=true"
import script from "./ProxyRouteList.vue?vue&type=script&lang=js"
export * from "./ProxyRouteList.vue?vue&type=script&lang=js"
import style0 from "./ProxyRouteList.vue?vue&type=style&index=0&id=b2dd828e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2dd828e",
  null
  
)

export default component.exports